import { OrganizationFull, User } from 'api/model'
import { atom, atomFamily } from 'recoil'

const organizationFamily = atomFamily<OrganizationFull | null, string>({
  key: 'organizations',
  default: null,
})

const organizationMembersAtom = atom<User[] | null>({
  key: 'organizationMembers',
  default: null,
})

export { organizationFamily, organizationMembersAtom }
